import { Box, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Layout } from "@/shared/layout";
import LandingHero from "@/features/landing-hero";
import AboutImage from "@/app/assets/images/about.png";
import HowItWorks from "@/features/how-it-works";
import Questions from "@/features/questions";
import { Footer } from "@/shared/footer";
import OurPartners from "@/features/our-partners";
import OurCertificates from "@/features/our-certificates";

export const HomePage = () => {
  const { t } = useTranslation("landing");

  return (
    <>
      <Layout>
        <LandingHero />
      </Layout>
      <section id="about">
        <Container
          maxWidth={"xl"}
          sx={{
            height: "100%",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            justifyContent={{
              xs: "center",
              xl: "space-between",
            }}
            mt={10}
            mb={5}
          >
            <Stack direction="column">
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,
                  fontSize: "34px",
                  color: "#0B1370",
                  marginBottom: "32px",
                }}
              >
                {t("about_title")}
              </Typography>

              <Typography
                variant="h2"
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: "14px", sm: "18px", md: "23px" },
                  lineHeight: { xs: "18px", sm: "26px", md: "32px" },
                  maxWidth: "640px",
                  color: "#484848",
                }}
              >
                {t("about_subtitle")}
              </Typography>
            </Stack>
            <Box
              component="img"
              src={AboutImage}
              alt="About Section"
              sx={{ minWidth: "320px" }}
            />
          </Stack>
        </Container>
      </section>

      <HowItWorks />

      <OurPartners />
      <OurCertificates />
      <Questions />

      <Container
        maxWidth={"xl"}
        sx={{
          height: "100%",
        }}
      >
        <Footer />
      </Container>
    </>
  );
};
